import { type LawPayload } from '#app/services/ai/types.ts'
import { type LegalSourceCitationBehavior } from '#app/services/legal-ai/shared/source-contract.ts'

type LawCitationPayload = Omit<LawPayload, 'content'> & { id: string | number }

export function cleanUrlOfLaw(urlString: string) {
	// leave only the nValor1 and nValor2 params on the url, remove all others
	let url = new URL(urlString)
	let newParams = new URLSearchParams()
	for (let [key, value] of url.searchParams.entries()) {
		if (['nValor1', 'nValor2'].includes(key)) {
			newParams.append(key, value)
		}
	}
	let newUrl = new URL(url.origin + url.pathname + '?' + newParams.toString())
	return newUrl.toString()
}

export function lawDocumentAsTitle(payload: LawCitationPayload) {
	if (payload.date) {
		return `${payload.date} - ${payload.title}`
	}
	return payload.title
}

export function getLawDocumentFallbackUrl(documentId: string) {
	return `/enlace/ley/${encodeURIComponent(documentId)}`
}

export const costaRicaNormativaCitation: LegalSourceCitationBehavior<LawPayload> = {
	title: payload => payload.title,
	url: payload => cleanUrlOfLaw(payload.full_text_url),
	inlineTagName: 'lawdocument',
	legacyTagNames: ['LawDocument', 'law-document'],
	fallbackUrl: getLawDocumentFallbackUrl,
	iconName: 'feather',
	linkClassName: 'text-indigo-600',
	summaryLabel: 'normativas',
	summaryIconName: 'file-text',
	summaryIconClassName: 'text-amber-500',
	summaryDotClassName: 'bg-amber-500',
	summaryTitle: payload => payload.title,
}
